export const COMPANY_NAME = "NGenuity Nurse Education";
export const COMPANY_SHORT = "NGenuity Nurse Education";
export const COMPANY_INITIALS = "NNE";
export const COMPANY_ADDRESS_FULL = "18729 E Glenlyn Dr, Azusa, California, US 91702-4018";
export const COMPANY_LOCATION = "Azusa, California";
export const COMPANY_REGION = "Los Angeles County";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=18729%20E%20Glenlyn%20Dr%2C%20Azusa%2C%20California%2C%20US%2091702-4018";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1505751172876-fa1923c5c528?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Profile type", "value": "Nurse education" },
  { "label": "Region", "value": "Los Angeles County" },
  { "label": "Location", "value": "Azusa, California" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "NGenuity Nurse Education" },
  { "label": "Location", "value": "Azusa, California" },
  { "label": "Address", "value": "18729 E Glenlyn Dr, Azusa, California, US 91702-4018" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "Directory profile", "body": "A concise public profile with organization and location details." },
  { "icon": "✦", "title": "Education focus", "body": "Nurse education is reflected only as part of the organization name and profile focus." },
  { "icon": "✿", "title": "Local presence", "body": "Public location information for Azusa, California." },
  { "icon": "❍", "title": "Plan a visit", "body": "Use the map link for directions to the listed address." },
];
